import React, { ReactElement, useMemo } from "react";
import TextField from "../TextField";
import PasswordRequirementToolTip from "./PasswordRequirementTooltip";
import EyeOnIcon from "@mui/icons-material/VisibilityOutlined";
import EyeOffIcon from "@mui/icons-material/VisibilityOffOutlined";
import { commonStyles } from "../commonStyles";

const PasswordField = ({
  id,
  fieldName,
  label,
  value,
  onChange,
  touched,
  error,
  disablePopup = false,
}: {
  id: string;
  fieldName: string;
  label: string;
  value: string;
  onChange: (e: any) => void;
  touched: boolean | undefined;
  error: string | undefined;
  disablePopup?: boolean;
}): ReactElement => {
  const [showPasswordTooltip, setShowPasswordTooltip] = React.useState(false);

  const [hideTextBingo, setHideTextBingo] = React.useState(true);

  const visible = useMemo(() => {
    if (hideTextBingo) {
      return false;
    }
    return true;
  }, [hideTextBingo]);

  return (
    <div style={{ position: "relative", width: "100%" }}>
      {showPasswordTooltip ? (
        <PasswordRequirementToolTip passwordText={value} />
      ) : null}

      <TextField
        onFocus={() => {
          if (!disablePopup) {
            setShowPasswordTooltip(true);
          }
        }}
        onBlur={() => {
          if (!disablePopup) {
            setShowPasswordTooltip(false);
          }
        }}
        fullWidth
        id={id}
        name={fieldName}
        label={label}
        value={value}
        onChange={onChange}
        error={touched && Boolean(error)}
        helperText={touched && error}
        type={visible ? "text" : "password"}
      />
      <div
        style={{
          position: "absolute",
          top: 40,
          right: 15,
        }}
      >
        {visible ? (
          <EyeOffIcon
            sx={{
              fontSize: commonStyles.fontSizes.xlarge,
            }}
            onClick={() => {
              setHideTextBingo(!hideTextBingo);
            }}
          />
        ) : (
          <EyeOnIcon
            sx={{
              fontSize: commonStyles.fontSizes.xlarge,
            }}
            onClick={() => {
              setHideTextBingo(!hideTextBingo);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default PasswordField;
